const placementTestFields = [
  {
    name: "title",
    label: "Test Title",
    type: "text",
    placeholder: "Type test title",
  },
  {
    name: "description",
    label: "Description",
    type: "textarea",
    placeholder: "Test Description",
  },
  {
    name: "price",
    label: "Price",
    type: "number",
    placeholder: "Test Price",
  },
  {
    name: "type",
    label: "Placement Type",
    type: "select",
    options: [
      { value: "pre_enrollment", label: "Course Placement (Pre-enrollment)" },
      { value: "standalone", label: "Standalone" },
    ],
    placeholder: "Select type",
  },
  {
    name: "course_id",
    label: "Course",
    type: "select",
    options: [],
    placeholder: "Select Course",
  },

  {
    name: "max_attempts",
    label: "Max Attempts (Optional)",
    type: "number",
    placeholder: "Leave empty for unlimited",
  },
  {
    name: "start_date",
    label: "Start Date",
    type: "datepicker",
    placeholder: "Select Start Date",
  },

  {
    name: "duration_minutes",
    label: "Duration (Minutes)",
    type: "number",
    placeholder: "Test Duration",
  },
  {
    name: "full_marks",
    label: "Full Marks",
    type: "number",
    placeholder: "e.g. 100",
  },
  {
    name: "passing_score",
    label: "Passing Score (%)",
    type: "number",
    placeholder: "e.g. 50",
  },
  {
    name: "status",
    label: "Status",
    type: "select",
    options: [
      { value: "draft", label: "Draft" },
      { value: "published", label: "Published" },
      { value: "archived", label: "Archived" },
    ],
    placeholder: "Select Status",
  },
];

export default placementTestFields;
